import { create } from "zustand";

interface ToastState {
  isVisible: boolean; // 토스트 노출 여부
  message: string; // 메세지
  timer?: ReturnType<typeof setTimeout>;
  showToast: (message: string, delay?: number) => void;
  hideToast: () => void;
}

export const useToastStore = create<ToastState>((set, get) => ({
  isVisible: false,
  message: "",
  timer: undefined,

  // 토스트 노출
  showToast: (message: string, delay?: number) => {
    const { timer, hideToast } = get();
    timer && clearTimeout(timer);

    const setDelay = delay ?? 3000;
    const newTimer = setTimeout(() => hideToast(), setDelay);

    set({ isVisible: true, message, timer: newTimer });
  },

  // 토스트 숨김
  hideToast: () => {
    const { timer } = get();
    timer && clearTimeout(timer);
    set({ isVisible: false, timer: undefined });
  },
}));
